import { Linkedin, Copy } from "lucide-react";
import { useState } from "react";

const ShareButtons = ({ title }) => {
  const [copied, setCopied] = useState(false);
  const url = window.location.href;

  const shareLinkedIn = () => {
    const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      url
    )}&title=${encodeURIComponent(title)}`;
    window.open(linkedInUrl, "_blank");
  };

  const copyText = () => {
    const shareText = `I just read "${title}" on NeuralBrew ☕
Really thoughtful insights on real-world data engineering.
${url}`;
    navigator.clipboard.writeText(shareText);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="flex flex-col justify-center items-center mt-10">
      <button
        onClick={shareLinkedIn}
        className="flex items-center gap-2 px-5 py-2 rounded-full
        bg-gradient-to-r from-[#00e0b7] to-[#4b5fff] text-white font-semibold
        shadow-md hover:shadow-[0_0_18px_rgba(0,224,183,0.25)] hover:-translate-y-0.5
        transition"
      >
        <Linkedin size={18} />
        Share on LinkedIn
      </button>

      {/* Copy Text Helper */}
      <button
        onClick={copyText}
        className="flex items-center gap-2 mt-3 text-xs text-slate-400 hover:text-white transition"
      >
        <Copy size={14} />
        {copied ? "Copied!" : "Copy share message"}
      </button>
    </div>
  );
};

export default ShareButtons;
